const subsText = (subs) => (subs || []).map((s) => `${s.stat} ${s.value ?? ""}`.trim()).join(", ");
const parseSubs = (t) => t.split(",").map((x) => x.trim()).filter(Boolean).map((x) => {
  const m = x.match(/^(.*?)\s*([-+]?[\d.]+\s*[%s]?)$/);
  return m ? { stat: m[1].trim(), value: m[2].trim() } : { stat: x, value: "" };
});

export const ReadingEditor = ({ reading, onChange, testid }) => {
  const pieces = reading.pieces || [];
  const setPiece = (i, patch) => onChange({ ...reading, pieces: pieces.map((p, j) => (j === i ? { ...p, ...patch } : p)) });
  return (
    <div style={{ marginTop: 8 }} data-testid={`${testid}-reading`}>
      <label style={{ fontSize: 13, display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
        Initial Charge on the Ability screen (s)
        <input className="lg-input lg-mini" style={{ width: 90 }} value={reading.ability?.initialCharge ?? ""}
          onChange={(e) => onChange({ ...reading, ability: { ...reading.ability, initialCharge: e.target.value } })} data-testid={`${testid}-ic`} />
      </label>
      <div className="lg-scroll">
        <table className="lg-itable">
          <thead><tr><th>Piece</th><th>Set</th><th>Lv</th><th>★</th><th>Main stat</th><th>Main value</th><th>Sub-stats (stat value, …)</th></tr></thead>
          <tbody>{pieces.map((p, i) => (
            <tr key={`${i}-${subsText(p.subs)}`}>
              <td style={{ textTransform: "capitalize" }}>{p.slot}</td>
              <td><input className="lg-input lg-mini" value={p.set ?? ""} onChange={(e) => setPiece(i, { set: e.target.value })} data-testid={`${testid}-p${i}-set`} /></td>
              <td><input className="lg-input lg-mini" style={{ minWidth: 46 }} value={p.level ?? ""} onChange={(e) => setPiece(i, { level: e.target.value })} /></td>
              <td><input className="lg-input lg-mini" style={{ minWidth: 40 }} value={p.stars ?? ""} onChange={(e) => setPiece(i, { stars: e.target.value })} /></td>
              <td><input className="lg-input lg-mini" value={p.main?.stat ?? ""} onChange={(e) => setPiece(i, { main: { ...p.main, stat: e.target.value } })} data-testid={`${testid}-p${i}-main`} /></td>
              <td><input className="lg-input lg-mini" style={{ minWidth: 60 }} value={p.main?.value ?? ""} onChange={(e) => setPiece(i, { main: { ...p.main, value: e.target.value } })} /></td>
              <td><input className="lg-input lg-mini" style={{ minWidth: 260 }} defaultValue={subsText(p.subs)} onBlur={(e) => setPiece(i, { subs: parseSubs(e.target.value) })} data-testid={`${testid}-p${i}-subs`} /></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
};
